import { lazy, Suspense } from 'react';
import { View } from 'react-native';

const CodeRainBackground = lazy(() => import('./CodeRainBackground').then(mod => ({ default: mod.CodeRainBackground })));

interface Props {
  isActive: boolean;
}

export function LazyCodeRainBackground({ isActive }: Props) {
  if (!isActive) return null;

  return (
    <Suspense fallback={<View />}>
      <CodeRainBackground isActive={isActive} />
    </Suspense>
  );
}
